export default "__VITE_ASSET__faf92c46__"